var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("survey", { attrs: { survey: _vm.survey } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }